import { Link } from 'react-router-dom'

const AuditoriasDetalleRow = ({ data: {detalle, isIoma}}) => {
    return (
      <tr className='border-t border-lightGrey'>
        <td className='p-4 m-4'>{detalle.namePractices}</td>
        <td className='p-4 m-4'>{detalle.status}</td>
        {!isIoma && <td className='p-4 m-4'>${detalle.cost}</td>}
      </tr>
    )
  }
  
  const AuditoriasDetalleTable = ({ data: { auditoriasDetalle, isIoma, errorState } }) => {
    if (errorState?.error) {
      return (
        <div className="text-2xl font-bold p-4">
          {errorState.errorMessage + '.' || 'Ha ocurrido un error al cargar los detalles de auditoría.'}
        </div>
      );
    }
    const isFinalizado = auditoriasDetalle?.isFinalizado;
    const isUnscheduled = auditoriasDetalle?.isUnschedule;
    return (
      <div className=' lg:block w-full flex-1 text-lg text-left !text-[15px]'>
        
        <table className='flex-1 w-full'>
          <thead className='text-deactivatedDarkBlue'>
            <tr>
              <th className='font-normal pb-3'>Nombre practica</th>
              <th className='font-normal pb-3'>Autorizado</th>
              {!isIoma && <th className='font-normal pb-3'>Valor</th>}
            </tr>
          </thead>
          <tbody className='text-darkBlue'>
            {/* ACÁ TIENE QUE SER AUDITORIASDETALLE.PRACTICAS */}
            {auditoriasDetalle?.practicas?.map((detalle, index) => 
              <AuditoriasDetalleRow key={index} data={{detalle, isIoma}} />
            )}
            {/* {auditoriasDetalle.map((auditoriasDetalle, index) => (
              <AuditoriasDetalleRow key={index} data={{auditoriasDetalle}} />)
            )} */}
            <tr className="border-t border-darkGrey">
              {/* columna del total */}
              <th
                colSpan={isIoma ? 2 : 3} 
                className="text-2xl font-bold p-4 text-left"
              >
                {auditoriasDetalle.total
                  ? `${auditoriasDetalle.total}`
                  : "Total: $0"}
              </th>
              <td className="p-4 text-right">
                {isFinalizado ? (
                  <div
                    className="w-full lg:max-w-max text-white shadow-6 py-4 px-6 400:px-11 rounded-lg flex-1 md:flex-0 text-center bg-gray-400 flex items-center justify-center gap-2 cursor-not-allowed"
                  >
                    PAGO REALIZADO
                  </div>
                ) : isUnscheduled ? (
                  <Link
                    to={`/pago`}
                    state={{
                      total: auditoriasDetalle?.total,
                      transaction: auditoriasDetalle?.transaction
                    }}
                    rel="noopener noreferrer"
                    className="w-full lg:max-w-max text-white shadow-6 py-4 px-6 400:px-11 rounded-lg flex-1 md:flex-0 text-center bg-cyan flex items-center justify-center gap-2"
                  >
                    Pagar
                  </Link>
                ) : null}
              </td>
              {/* CAMBIO QUE MUESTRA QR A SCHEDULED Y UNSCHEDULED */}
             {/* <td className="p-4 text-right">
              
            <td className="p-4 text-right">
              {isFinalizado ? (
                <div
                  className="w-full lg:max-w-max text-white shadow-6 py-4 px-6 400:px-11 rounded-lg flex-1 md:flex-0 text-center bg-gray-400 flex items-center justify-center gap-2 cursor-not-allowed"
                >
                  PAGO REALIZADO
                </div>
              ) : (
                isUnschedule && (
                  <Link
                    to="/pago"
                    state={{
                      total: auditoriasDetalle?.total,
                      transaction: auditoriasDetalle?.transaction
                    }}
                    rel="noopener noreferrer"
                    className="w-full lg:max-w-max text-white shadow-6 py-4 px-6 400:px-11 rounded-lg flex-1 md:flex-0 text-center bg-cyan flex items-center justify-center gap-2"
                  >
                    Pagar
                  </Link>
                )
              )}
            </td> */}

            </tr>
          </tbody>
        </table>
      </div>
    )
  }
  
  const AuditoriasDetalleList = ({data}) => {
    return (
      <div className='w-full flex-1'>
        <AuditoriasDetalleTable data={data} />
      </div>
    );
  }
  
  export default AuditoriasDetalleList